<template>
  <div class="ChangePassword">
    <div class="header syTitle acea-row row-center-wrapper">
        立数教育校园收费通管理平台软件使用协议
    </div>

    <div class="textView">
 <div class="acea-row">
   使用本平台必须遵守下述协议：
   </div>
   <div class="acea-row row-center-wrapper">
     1、管理平台操作者本人必须是与本平台签约单位的授权工作人员。
   </div>
   <div class="acea-row row-center-wrapper">
     2、管理平台操作者有义务把更改后的手机号或微信号及时提交后台，如不及时更改造成的一切用户损失、不良反映后果由使用者担当，平台不负任何责任。
   </div>
   <div class="acea-row row-center-wrapper">
     3、非签约单位人员通过非正常手段使用本系统，造成用户损失和不良社会影响，本平台保留追诉的权利，并向公安网络管理部门报案。
   </div>
    <div class="acea-row row-center-wrapper">
    4、本“软件产品”（包括但不限于本“软件产品”中所含的任何图象、照片、动画、录像、录音、音乐、文字和附加程序）、随附的印刷材料、及本“软件产品”的任何副本的产权和知识产权，均由深圳市立数教育科技有限公司拥有。深圳市立数教育科技有限公司拥有随时更新、修改软件和增删功能的权限，无须提前告知使用者。
    </div>

    </div>
    

    <div class="acea-row row-center-wrapper text2">
        深圳市立数教育科技有限公司
    </div>
    <div class="acea-row row-center-wrapper text1">
        2019.12
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import sendVerifyCode from "@mixins/SendVerifyCode";
import { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { bindingPhone, sendSMS } from "@api/public";
import cookie from "@utils/store/cookie";

export default {
  name: "BindingPhone",
  components: {},
  props: {},
  data: function() {
    return {
      verifyCode: "",
      phone: "" //手机号
    };
  },
  mixins: [sendVerifyCode],
  computed: mapGetters(["userInfo"]),
  mounted: function() {},
  methods: {
    async confirm() {
      let that = this;
      const { phone, verifyCode } = that;
      let openid = cookie.get("lishu-openid");

      console.log(openid);

      bindingPhone(phone,openid,verifyCode)
                    .then((data, res) => {
                      console.log(data);

          if (data.code == 0) {

            that.$dialog.success(data.msg).then(() => {
              //  this.$router.replace({
              //       path: "/"
              //   });
                window.location.href = "http://datum.lishuedu.com/";
            });

          } else {
            that.$dialog.error(data.msg).then(() => {
                // this.$router.replace({
                //     path: "/"
                // });
            });
          }
        });

    },
    async code() {
      let that = this;
      const { phone } = that;
  
      // let ret = chs_phone(phone);
      // console.log(ret);

      function isPoneAvailable(phone) {
            var myreg=/^[1][3,4,5,7,8][0-9]{9}$/;
            if (!myreg.test(phone)) {
                return false;
            } else {
                return true;
            }
        }

      if (isPoneAvailable(phone) == false) {
        that.$dialog.toast({ mes: "请输入正确手机号!!" });
        return;
      }

      sendSMS(phone)
        .then((data, res) => {
          if (data.code == 0) {
            that.$dialog.success("发送成功");

            that.sendCode();
          }else{
            that.$dialog.error(data.msg);
          }
          
        })
        .catch(res => {
        });
    }
  }
};
</script>

<style scoped>
.index {
  background-color: #fff;
}
.btnView{
  background-color:#2EBCBF;
}
.syTitle {
  color: black;
  font-size: 18px;
  height: 50px;
}

.textView {
  margin: 10px;
}
.text1 {
  margin-top: 10px;
}
.text2 {
  margin-top: 20%;
}
</style>
